import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center py-10 px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "mt-3 text-gray-600" }
const _hoisted_3 = { class: "text-gray-600" }
const _hoisted_4 = { class: "mt-5 flex flex-col justify-center items-center gap-2 sm:flex-row sm:gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "block text-7xl font-bold text-gray-800 sm:text-9xl" }, "404", -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('404.title')), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('404.subtitle')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "w-auto py-2 px-3 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-hidden focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("svg", {
            class: "shrink-0 size-4",
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "m15 18-6-6 6-6" })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('404.subtitle')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}